import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierTaskPage.components.FileUpload.components.ErrorDialog.title',
    defaultMessage: 'The following errors occurred',
  },
})
